<template>
    <b-form @submit="this.$parent.onSubmit">
        <b-form-group id="name-label" label="Meno:" label-for="name">
            <b-input
                id="name"
                type="text"
                v-model="user.name"
                required
                placeholder="Vložte meno"
            ></b-input>
        </b-form-group>

        <b-form-group id="email-label" label="Email:" label-for="email">
            <b-input
                id="email"
                type="email"
                v-model="user.email"
                required
                placeholder="Vložte email"
            ></b-input>
        </b-form-group>

        <b-form-group id="name-label1" label="Heslo:" label-for="password">
            <b-input-group class="mb-2">
                <b-form-input
                    name="password"
                    v-model="user.password"
                    :type="passwordType"
                    placeholder="Zadajte heslo"
                ></b-form-input>
                <b-input-group-append is-text v-on:click="this.togglePassword">
                    <b-icon :icon="icon"></b-icon>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>

        <br />
        <b-button type="submit" block variant="primary">Odoslať </b-button>
    </b-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "UserForm",
    data() {
        return {
            icon: "eye",
            passwordType: "password",
            invalid: false
        };
    },
    methods: {
        togglePassword() {
            this.passwordType =
                this.passwordType === "password" ? "text" : "password";
            this.icon = this.icon === "eye" ? "eye-slash" : "eye";
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        })
    }
};
</script>

<style scoped></style>
